import DynamicObject from "../../models/dynamic-object";
import { AxiosResponse} from "axios";
import Api from "../api";

export default (listingId : number, page: number, sort?: string, filter?: string ,config?: DynamicObject): Promise<AxiosResponse> => {
    const path = 'recruiter/v1/applicants'
    return Api.getInstance(true,false).request.get(`${path}/${listingId}?page=${page}${sort ? `&sort=${sort}` : ''}${filter ? `&filters=${filter}` : ''}`, path)
}